import { render, staticRenderFns } from "./enroll_students.vue?vue&type=template&id=722aa635&"
import script from "./enroll_students.vue?vue&type=script&lang=js&"
export * from "./enroll_students.vue?vue&type=script&lang=js&"
import style0 from "./enroll_students.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports